import { useEffect } from "react";
import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {usePathname} from "next/navigation";

gsap.registerPlugin(ScrollTrigger, SplitText);

const useSplitTextAnimation = (selector, dependencies = []) => {
    const pathName = usePathname();


    useEffect(() => {
        if(window.innerWidth > 992){



            const elements = gsap.utils.toArray(selector);


            elements.forEach((item) => {
                // Store original HTML content and letter spacing
                const originalHTML = item.innerHTML;
                const originalLetterSpacing = window.getComputedStyle(item).letterSpacing;

                const parentSplit = new SplitText(item, {
                    linesClass: "split-parent",
                });

                const childSplit = new SplitText(item, {
                    type: "lines, chars",
                    linesClass: "split-child",
                });

                gsap.from(parentSplit.lines, {
                    duration: 1,
                    yPercent: 100,
                    scrollTrigger: {
                        trigger: item,
                        start: "top 90%",
                        once: true,
                    },
                });

                return () => {
                    // Revert the split text to the original HTML
                    parentSplit.revert();
                    childSplit.revert();

                    // Restore the original letter spacing
                    item.style.letterSpacing = originalLetterSpacing;
                };
            });

            // Clean up the scroll triggers
            return () => {
                ScrollTrigger.getAll().forEach(trigger => trigger.kill());
            };
        }
    }, dependencies);

    useEffect(() => {
        if (window.location.hash) {
            gsap.to(window, { duration: 0.7, scrollTo: window.location.hash });
        }
        ScrollTrigger.refresh();

    }, [dependencies]);
};

export default useSplitTextAnimation;
